export const adminConstants = {

    FETCH_ADMINS_REQUEST: 'FETCH_ADMINS_REQUEST',
    FETCH_ADMINS_SUCCESS: 'FETCH_ADMINS_SUCCESS',
    FETCH_ADMINS_FAILURE: 'FETCH_ADMINS_FAILURE',

    CREATE_ADMIN_REQUEST: 'CREATE_ADMIN_REQUEST',
    CREATE_ADMIN_SUCCESS: 'CREATE_ADMIN_SUCCESS',
    CREATE_ADMIN_FAILURE: 'CREATE_ADMIN_FAILURE',

    UPDATE_ADMIN_REQUEST: 'UPDATE_ADMIN_REQUEST',
    UPDATE_ADMIN_SUCCESS: 'UPDATE_ADMIN_SUCCESS',
    UPDATE_ADMIN_FAILURE: 'UPDATE_ADMIN_FAILURE',

    DISABLE_ADMIN_REQUEST: 'DISABLE_ADMIN_REQUEST',
    DISABLE_ADMIN_SUCCESS: 'DISABLE_ADMIN_SUCCESS',
    DISABLE_ADMIN_FAILURE: 'DISABLE_ADMIN_FAILURE',

}